import { Modal } from 'components/Modal';
import { FC, useState } from 'react';
import { Button } from 'ui/Button';
import { ReactComponent as Check } from './img/check.svg';
import styles from './ModalApproveRefund.module.scss';
import { Loader } from '@mantine/core';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { useApproveRefundMutation } from 'redux/Api/refundApi/refundApi';

interface ModalApproveRefundTypes {
  setShow: (e: boolean) => void;
  show: boolean;
  customerName: string;
  refundId: number;
  setShowSuccessErrorInfo: (e: { text: string; type: 'success' | 'error' }) => void;
}

export const ModalApproveRefund: FC<ModalApproveRefundTypes> = ({
  setShow,
  show,
  customerName,
  refundId,
  setShowSuccessErrorInfo,
}) => {
  const [errorText, setErrorText] = useState('');
  const [approveRefund, { isLoading }] = useApproveRefundMutation();

  const handleApproveRefund = () => async () => {
    if (!refundId) return;
    setErrorText('');

    const expectedPassword = process.env.REACT_APP_PASSWORD_UPDATE_PROFILE || '';

    const enteredPassword = window.prompt('Введите пароль для подтверждения изменений');

    if (enteredPassword === null) {
      return;
    }

    if (enteredPassword !== expectedPassword) {
      window.alert('Неверный пароль');
      return;
    }
    try {
      await approveRefund({ refundId }).unwrap();
      setShowSuccessErrorInfo({
        text: 'Вывод средств успешно подтвержден',
        type: 'success',
      });
      setShow(false);
    } catch (error) {
      console.error(error);

      setErrorText(
        (error as { data?: { message?: string } }).data?.message ||
          'Ошибка при подтверждении вывода средств',
      );
    }
  };

  return (
    <>
      {show && (
        <Modal setOpen={setShow} open={show}>
          <div className={styles.root}>
            <p className={styles.title}>Внимание!</p>

            <p className={styles.info}>
              <span> Подтвердить вывод средств с платформы для {customerName}</span>
            </p>

            <div className={styles.btn_wrapper}>
              <Button
                onClick={() => setShow(false)}
                theme='outline'
                className={styles.btn_cancel}
                size='L'>
                <IconCancel />
              </Button>
              <Button
                size='L'
                className={styles.btn}
                theme='filed'
                onClick={handleApproveRefund()}
                disabled={isLoading}>
                <div className={styles.textBtn}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    Подтвердить
                    <div style={{ width: '22px', height: '22px' }}>
                      {isLoading ? (
                        <Loader size='xs' color='white' />
                      ) : (
                        <Check style={{ width: '22px', height: '22px' }} />
                      )}
                    </div>
                  </div>
                </div>
              </Button>
            </div>
            {errorText && <p className={styles.errorText}>{errorText}</p>}
          </div>
        </Modal>
      )}
    </>
  );
};
